document.addEventListener("DOMContentLoaded", () => {
  const easifyOptions = document.querySelector('.easify-product-options');

  const sizeConfiguration = {
    '6mm': {
      '14cm': 26,
      '15cm': 27,
      '16cm': 29,
      '17cm': 31,
      '18cm': 33,
      '19cm': 34,
      '20cm': 36,
      '21cm': 38,
      '22cm': 40,
      '23cm': 42
    },
    '8mm': {
      '14cm': 21,
      '15cm': 22,
      '16cm': 23,
      '17cm': 24,
      '18cm': 25,
      '19cm': 26,
      '20cm': 28,
      '21cm': 29,
      '22cm': 30,
      '23cm': 31
    },
  };
  
  const urlParams = new URLSearchParams(window.location.search);
  const b1 = urlParams.get('b1');
  if (!b1) {
    const productWrapper = document.querySelector('.product');
    productWrapper.classList.remove('personalized-product--loading');
  }
  
  if (easifyOptions) {
    const config = { childList: true };
    const observer = new MutationObserver((mutationsList, observer) => {
      for(const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          initBracelet();
         }
      }
    });
  
    observer.observe(easifyOptions, config);
  }

  function initBracelet() {
    const defaultBraceletSize = '17cm';
    const defaultBeadSize = '6mm';
    const defaultBeadNumber = 26;

    const beadsSizeOption = easifyOptions.querySelector('[name="properties[beads-size]"]');
    const braceletSizeOption = easifyOptions.querySelector('[name="properties[size]"]');

    let beadSize = defaultBeadSize;
    if (beadsSizeOption) {
      beadSize = beadsSizeOption.value;
    }

    let beadsNumber = defaultBeadNumber;
    let braceletSize = defaultBraceletSize;
    
    if (braceletSizeOption) {
      braceletSize = getValueWithoutPrice(braceletSizeOption.value);
      beadsNumber = sizeConfiguration[beadSize][braceletSize];
    }
    
    if (braceletSizeOption) {
      braceletSizeOption.addEventListener('change', function() {
        beadSize = getValueWithoutPrice(beadsSizeOption.value);
        
        if (sizeConfiguration[beadSize]) {
          beadsNumber = sizeConfiguration[beadSize][getValueWithoutPrice(braceletSizeOption.value)];
        }

        generateBracelet(beadSize, beadsNumber);
      });
    }
    
    if (beadsSizeOption) {
      beadsSizeOption.addEventListener('change', function() {
        beadSize = getValueWithoutPrice(beadsSizeOption.value);

        if (sizeConfiguration[beadSize]) {
          beadsNumber = sizeConfiguration[beadSize][getValueWithoutPrice(braceletSizeOption.value)];
        }
        
        generateBracelet(beadSize, beadsNumber);
      });
    }

    generateBracelet(beadSize, beadsNumber);

    initBeadsSelection();
  }

  function getValueWithoutPrice(value) {
    return value.replace(/\[.*?\]/g, '').trim();
  }

  function generateBracelet(beadSize, beadsNumber) {
    const mediaWrapper = document.querySelector('.product__media-wrapper');
    if (mediaWrapper) {
      while (mediaWrapper.firstChild) {
        mediaWrapper.removeChild(mediaWrapper.firstChild);
      }

      const diametreBead = parseInt(beadSize) * 6;
      const diametreBracelet = (diametreBead * beadsNumber) / Math.PI;
      
      const centerX = diametreBracelet / 2;
      const centerY = diametreBracelet / 2;
  
      const dynamicBracelet = document.createElement('div');
      dynamicBracelet.classList.add('dynamic-bracelet');
      dynamicBracelet.setAttribute(
        'style', 
        '--bracelet-size:' + diametreBracelet + 'px;' +
        '--bead-size:' + diametreBead + 'px'
      );
      mediaWrapper.append(dynamicBracelet);

      for (let i = 0; i < beadsNumber; i++) {
        const angle = (i / beadsNumber) * Math.PI * 2;
        const x = centerX + (diametreBracelet / 2 ) * Math.cos(angle);
        const y = centerY + (diametreBracelet / 2 ) * Math.sin(angle);
        
        const bead = document.createElement('span');
        bead.classList.add('dynamic-bracelet__bead');
        bead.style.top = y - diametreBead / 2 + 'px';
        bead.style.left = x - diametreBead / 2 + 'px';
        
        dynamicBracelet.appendChild(bead);
      }

      beadsHandler();
    }
  }

  function initBeadsSelection() {
    const choiceSubmitButtons = document.querySelectorAll('.tpo_modal-footer-group .primary');
    choiceSubmitButtons.forEach(btn => {
      btn.addEventListener('click', function() {
        beadsHandler();
      });
    });

    const searchInput = document.querySelectorAll('.tpo_option-input');
    searchInput.forEach(input => {
      input.setAttribute('placeholder', 'Rechercher une pierre...');
    });

    const modalContent = document.querySelectorAll('.tpo_modal-content');
    modalContent.forEach(content => {
      initSelectors(content);
      initIllsSwitcher(content);
      initFirstSwitcher(content);
      switchersHandler(content);
      selectorsHandler(content);
    });

    preselectedBeadsHandler();
  }

  function preselectedBeadsHandler() {
    const urlParams = new URLSearchParams(window.location.search);
    const b1 = urlParams.get('b1');
    const b2 = urlParams.get('b2');
    const b3 = urlParams.get('b3');
    const b4 = urlParams.get('b4');
    if (b1) {
      selectBead(b1, 0);
      selectBead(b2, 1);
      selectBead(b3, 2);
      selectBead(b4, 3);
    }
  }

  function selectBead(bead, index) {
    if (bead) {
      const modals = document.querySelectorAll('.tpo_modal-background');
      const modalButtons = document.querySelectorAll('.tpo_popup-modal-button');
      
      const modal = modals[index];
      const button = modalButtons[index];

      setTimeout(function() {
        button.dispatchEvent(new Event('click'));
        
        const beads = modal.querySelectorAll('.tpo_radio-button');
        beads.forEach(_bead => {
          if (_bead.getAttribute('value') == bead) {
            _bead.click();
          }
        });
        
        const submitButton = modal.querySelector('.button-modal.primary');
        submitButton.dispatchEvent(new Event('click'));

        const productWrapper = document.querySelector('.product');
        productWrapper.classList.remove('personalized-product--loading');
      }, 1000);
    }
  }

  function beadsHandler(bead) {
      const bead1 = document.querySelector('[name="bead-1"]:checked');
      const bead2 = document.querySelector('[name="bead-2"]:checked');
      const bead3 = document.querySelector('[name="bead-3"]:checked');
      const bead4 = document.querySelector('[name="bead-4"]:checked');

      let image1 = null;
      let image2 = null;
      let image3 = null;
      let image4 = null;

      if (bead1) {
        image1 = bead1.nextElementSibling.querySelector('img')
      }
      if (bead2) {
        image2 = bead2.nextElementSibling.querySelector('img')
      }
      if (bead3) {
        image3 = bead3.nextElementSibling.querySelector('img')
      }
      if (bead4) {
        image4 = bead4.nextElementSibling.querySelector('img')
      }

      updateBraceletStyle(image1, image2, image3, image4);
  }
  
  function updateBraceletStyle(b1, b2, b3, b4) {
    const beads = document.querySelectorAll('.dynamic-bracelet__bead');
    const beadsNumber = beads.length;
    let nextBeadType = 1;

    beads.forEach(bead => {
      switch (nextBeadType) {
        case 1:
          if (b1) {
            bead.style.backgroundImage = 'url(' + b1.src + ')';
          } else {
            bead.style.backgroundImage = 'none';
          }
          
          if (b2) {
            nextBeadType = 2;
          }
          break;
        case 2:
          bead.style.backgroundImage = 'url(' + b2.src + ')';
          if (b3) {
            nextBeadType = 3;
          } else {
            nextBeadType = 1;
          }
          break;
        case 3:
          bead.style.backgroundImage = 'url(' + b3.src + ')';
          if (b4) {
            nextBeadType = 4;
          } else {
            nextBeadType = 1;
          }
          break;
        case 4:
          bead.style.backgroundImage = 'url(' + b4.src + ')';
          nextBeadType = 1;
          break;
      }

      if (b1) {
        bead.style.border = '0';
      } else {
        bead.style.border = '1px dashed black';
      }
    });
  }

  function initFirstSwitcher(content) {
    const firstSwitch = document.createElement('div');
    firstSwitch.innerHTML = '<span class="tpo_modal-switch-item active" data-switch="ills">Sélection par maux</span><span data-switch="stones" class="tpo_modal-switch-item">Sélection par pierre</span>';
    firstSwitch.classList.add('tpo_modal-switch');
    content.prepend(firstSwitch);
  }

  function initIllsSwitcher(content) {
    const illsSwitch = document.createElement('div');
    illsSwitch.innerHTML = '<span class="tpo_modal-switch-item active" data-selector-toggle="physical">Physique</span><span data-selector-toggle="mental" class="tpo_modal-switch-item">Mentaux</span><span data-selector-toggle="spiritual" class="tpo_modal-switch-item">Spirituels</span>';
    illsSwitch.classList.add('tpo_modal-switch');
    illsSwitch.setAttribute('data-switch-content', 'ills');
    content.prepend(illsSwitch);
  }

  function switchersHandler(content) {
    const buttons = content.querySelectorAll('[data-switch]');
    buttons.forEach(button => {
      button.addEventListener('click', function() {
        const index = button.getAttribute('data-switch');
        const selectors = document.querySelectorAll('[data-switch-content="' + index + '"]');
  
        const others = content.querySelectorAll('[data-switch-content]');
        others.forEach(other => {
          other.style.display = 'none';
        });
        
        if (selectors.length > 0) {
          selectors.forEach(selector => {
            selector.style.display = 'flex';
          });
        }
        
        resetBeadsVisibility();
    
        buttons.forEach(_button => {
          _button.classList.remove('active');
        });
        button.classList.add('active');
      });
    });
  }

  function initSelectors(content) {
    const ills = JSON.parse(localStorage.getItem('ills'));
    const selectorWrapper = document.createElement('div');
    selectorWrapper.setAttribute('data-switch-content', 'ills');
    
    const physicalSelector = document.createElement('select');
    physicalSelector.innerHTML = '<option value="">Recherche un mal physique...</option>';
    for (const [ill, beads] of Object.entries(ills['physical'])) {
      const option = document.createElement('option');
      option.innerHTML = ill;
      option.value = ill;
      physicalSelector.append(option);
    }
    
    const mentalSelector = document.createElement('select');
    mentalSelector.innerHTML = '<option value="">Recherche un mal mental...</option>';
    for (const [ill, beads] of Object.entries(ills['mental'])) {
      const option = document.createElement('option');
      option.innerHTML = ill;
      option.value = ill;
      mentalSelector.append(option);
    }
    
    const spiritualSelector = document.createElement('select');
    spiritualSelector.innerHTML = '<option value="">Recherche un mal spirituel...</option>';
    for (const [ill, beads] of Object.entries(ills['spiritual'])) {
      const option = document.createElement('option');
      option.innerHTML = ill;
      option.value = ill;
      spiritualSelector.append(option);
    }
    
    physicalSelector.classList.add('tpo_modal-selector');
    mentalSelector.classList.add('tpo_modal-selector');
    spiritualSelector.classList.add('tpo_modal-selector');

    mentalSelector.style.display = 'none';
    spiritualSelector.style.display = 'none';
    
    physicalSelector.setAttribute('data-selector', 'physical');
    mentalSelector.setAttribute('data-selector', 'mental');
    spiritualSelector.setAttribute('data-selector', 'spiritual');
    
    selectorWrapper.prepend(physicalSelector);
    selectorWrapper.prepend(mentalSelector);
    selectorWrapper.prepend(spiritualSelector);

    content.prepend(selectorWrapper);
  }

  function selectorsHandler(content) {
    const ills = JSON.parse(localStorage.getItem('ills'));
    
    const toggles = content.querySelectorAll('[data-selector-toggle]');
    toggles.forEach(toggle => {
      toggle.addEventListener('click', function() {
        const index = toggle.getAttribute('data-selector-toggle');
        const selector = document.querySelector('[data-selector="' + index + '"]');
  
        const others = content.querySelectorAll('[data-selector]');
        others.forEach(other => {
          other.style.display = 'none';
          other.value = "";
        });
        
        if (selector) {
          selector.style.display = 'flex';
        }
        
        resetBeadsVisibility();
    
        toggles.forEach(_toggle => {
          _toggle.classList.remove('active');
        });
        toggle.classList.add('active');
      });
    });

    const selectors = content.querySelectorAll('[data-selector]');
    selectors.forEach(selector => {
      selector.addEventListener('change', function(){
        const beads = content.querySelectorAll('.tpo_product_list-wraper');
        const ill = selector.value;
        const type = selector.getAttribute('data-selector');
        const beads_in_ill = ills[type][ill];

        if (beads_in_ill) {
          beads.forEach(bead => {
            const name = bead.querySelector('.tpo_option_type_label').firstChild.textContent.slice(0, -1);
            if (beads_in_ill.includes(name)) {
              bead.style.display = "flex";
            } else {
              bead.style.display = "none";
            }
          });
        } else {
          resetBeadsVisibility();
        }
      });
    });
  }

  function resetBeadsVisibility() {
    const beads = document.querySelectorAll('.tpo_product_list-wraper');
    beads.forEach(bead => {
      bead.style.display = "flex";
   });
  }
});